import React from "react";
import "../widgets.styles.scss";
export function WidgetsChartCard(props) {
  return (
    <div
      className={`card col-12 col-lg p-3 ${
        (props.className !== undefined) & (props.className !== null) ? props.className : ""
      }`}
    >
      <div className="title d-flex flex-column flex-lg-row justify-content-between">
        <div className="d-flex d-flex align-items-center">
          <span className="fz-16 ff-univanova-600 text-cl-black me-3 d-flex align-items-center">{props.title}</span>
          <span className="ms-3 d-flex align-items-center">
            <div
              className={`${props.classNameFirstLegend} m-0`}
              style={{ width: "14px", height: "14px", borderRadius: "50%" }}
            ></div>
            <span className="ms-1">{props.firstLegend}</span>
          </span>
          <span className="ms-2 d-flex d-flex align-items-center">
            <div
              className={`${props.classNameSecondLegend} m-0`}
              style={{ width: "14px", height: "14px", borderRadius: "50%" }}
            ></div>
            <span className="ms-1">{props.secondLegend}</span>
          </span>
        </div>
        {props.filterYear ? (
          <form className=" border-auro-metal w-auto br-5">
            <select
              aria-expanded="true"
              className="widget-chart-card-year-select c-pointer form-select form-select-lg border-0 fz-14 box-shadow-none text-cl-auroMetal ff-univanova-regular notification-scroll"
            >
              <option value="today_year">Ano atual</option>
            </select>
          </form>
        ) : (
          <form className="  w-auto br-5 py-3 mt-2">
            {/* <select
              aria-expanded="true"
              className="widget-chart-card-year-select c-pointer form-select form-select-lg border-0 fz-14 box-shadow-none text-cl-auroMetal ff-univanova-regular notification-scroll "
            ></select> */}
          </form>
        )}
      </div>
      {props.children}
    </div>
  );
}
